const reenquiredFilterObjectReducer = (
    state = {},
    action: {
      type: "SET_REENQUIRED_FILTER_OBJECT" | "CLEAR_ALL_REENQUIRED_FILTERS";
      payload: any;
    }
  ) => {
    switch (action.type) {
      case "SET_REENQUIRED_FILTER_OBJECT":
        return { ...state, ...action.payload };
      case "CLEAR_ALL_REENQUIRED_FILTERS":
        return {};
      default:
        return state;
    }
  };
  
  export default reenquiredFilterObjectReducer;
  